import React from 'react';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../AppContext';

const ProSubscriptionModal = ({ onClose }) => {
    const { t } = useTranslation();
    const { appFunctions, setMessage } = useAppContext();

    const handleManageSubscription = async () => {
        const manageSubscription = httpsCallable(appFunctions, 'managePayPalSubscription');
        try {
            const result = await manageSubscription();
            if (result.data.managementUrl) {
                window.location.href = result.data.managementUrl;
            } else {
                setMessage("Could not retrieve subscription management link.");
            }
        } catch (error) {
            console.error("Error getting subscription management link:", error);
            setMessage(error.message);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="bg-gray-800/80 backdrop-blur-md p-6 rounded-lg shadow-glow max-w-md w-full text-white relative border border-purple-500/50">
                <h3 className="text-2xl font-bold mb-4 text-purple-300 font-playfair">{t('settings.subscription.pro.title')}</h3>
                <div className="bg-purple-900/20 p-6 rounded-lg border border-purple-500/30 shadow-glow-purple-light">
                    <h3 className="text-xl font-semibold mb-2">Status: <span className="text-green-400">Active</span></h3>
                    <p className="text-gray-300 mb-4">Thank you for being a vital part of the Harmony ecosystem!</p>
                    <button
                        onClick={handleManageSubscription}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300 shadow-md hover:shadow-lg"
                    >
                        {t('settings.subscription.manage')}
                    </button>
                    <p className="text-xs text-gray-400 mt-4 text-center">{t('settings.subscription.pro.cancelInstructions')}</p>
                </div>
                <button onClick={onClose} className="absolute top-3 right-3 p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50 transition duration-300" aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
            </div>
        </div>
    );
};

export default ProSubscriptionModal;
